"use client";

import { useEffect } from "react";
import { useAuthoringScope } from "../authoring-scope";
import { SiteHeader } from "../site-header";
import { DrillIcon } from "./icon";
import { RequestError } from "./types";

export function DrillShell({
  children,
  focused = false,
}: {
  children: React.ReactNode;
  focused?: boolean;
}) {
  const authoring = useAuthoringScope();
  if (authoring.admin)
    return <div className="drills-page admin-authoring-page">{children}</div>;
  return (
    <div className={`site-shell${focused ? " drill-focus" : ""}`}>
      <SiteHeader current="drills" hideDesktopNavigation={focused} />
      <main id="main-content" className="drills-page">
        {children}
      </main>
    </div>
  );
}

export function DrillError({ message }: { message: string }) {
  const authoring = useAuthoringScope();
  return (
    <div className="drill-error" role="alert">
      <p>{message}</p>
      {message.includes("ログイン") && (
        <a href={authoring.href("/login")} target="_blank" rel="noreferrer">
          別のタブでログイン <DrillIcon name="external" size={14} />
        </a>
      )}
    </div>
  );
}

export function redirectForAuth(error: unknown, loginHref = "/login") {
  if (error instanceof RequestError && error.status === 401) {
    window.location.assign(loginHref);
    return true;
  }
  return false;
}

export function useLeaveWarning(dirty: boolean) {
  useEffect(() => {
    if (!dirty) return;
    function warn(event: BeforeUnloadEvent) {
      event.preventDefault();
    }
    window.addEventListener("beforeunload", warn);
    return () => window.removeEventListener("beforeunload", warn);
  }, [dirty]);
}
